import { render } from "./ScriptPay.vue?vue&type=template&id=2b37241b"
import script from "./ScriptPay.vue?vue&type=script&lang=js"
export * from "./ScriptPay.vue?vue&type=script&lang=js"

import "./ScriptPay.vue?vue&type=style&index=0&id=2b37241b&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__